module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('str.DialogLoopLogin')))]), _vm._v(" "), _c('a', {
    staticClass: "socialnetwork",
    on: {
      "click": function($event) {
        _vm.login('linkedin')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/linkedin-button.svg")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socialnetwork",
    on: {
      "click": function($event) {
        _vm.login('facebook')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/facebook-button.svg")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "socialnetwork",
    on: {
      "click": function($event) {
        _vm.login('twitter')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/twitter-button.svg")
    }
  })]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.dlLogin
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icons/dialogloop-signin-button.svg")
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('str.NeedAnAccount')))]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "link-register",
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Register')))])])]), _vm._v(" "), (_vm.isModal('register')) ? _c('register', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModal('dlLogin')) ? _c('dl-login', {
    attrs: {
      "service": _vm.service
    },
    on: {
      "close": _vm.closeModal,
      "register": _vm.register
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733a760b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 480
// module chunks = 0